export const SET_LOADING_DATA = '@dailyRouteReport/SET_LOADING_DATA';
export const SET_LOADING_SELECTS = '@dailyRouteReport/SET_LOADING_SELECTS';

export const GET_LIST_ALL_REQUEST = '@dailyRouteReport/GET_LIST_ALL_REQUEST';
export const GET_LIST_ALL_SUCCESS = '@dailyRouteReport/GET_LIST_ALL_SUCCESS';

export const GET_LIST_SELECTS_REQUEST = '@dailyRouteReport/GET_LIST_SELECTS_REQUEST';
export const GET_LIST_SELECTS_SUCCESS = '@dailyRouteReport/GET_LIST_SELECTS_SUCCESS';

export const SHARE_CSV = '@dailyRouteReport/SHARE_CSV';

export const SET_PAGE = '@dailyRouteReport/SET_PAGE';
export const SET_ROWS_COUNT = '@dailyRouteReport/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@dailyRouteReport/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@dailyRouteReport/SET_ORDER';
export const SET_ORDERBY = '@dailyRouteReport/SET_ORDERBY';
